import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import H6 from '@base/H6/H6';
import Paper from '@base/Paper/Paper';
import { Spacings, Fonts } from '@styles/index';

const Wrapper = styled.div`
  display: flex;
  align-items: center;
`;

const IconWrapper = styled(Paper)`
  background-color: var(--color-divider);
  width: ${Spacings.SPACING_10B};
  height: ${Spacings.SPACING_10B};
  min-width: ${Spacings.SPACING_10B};
  min-height: ${Spacings.SPACING_10B};
  padding: 0;
  display: grid;
  place-items: center;
  margin-right: ${Spacings.SPACING_3B};
`;

const InfoTextWrapper = styled.div`
  width: auto;
`;

const InfoText = styled(H6)`
  width: auto;
`;

const InfoSubText = styled.div`
  width: auto;
  font-size: ${Fonts.SMALL};
`;

const StatCard = ({ icon, info }) => (
  <Wrapper>
    <IconWrapper>{icon}</IconWrapper>
    <InfoTextWrapper>
      <InfoText>{info.text}</InfoText>
      <InfoSubText>{info.subText}</InfoSubText>
    </InfoTextWrapper>
  </Wrapper>
);

StatCard.propTypes = {
  icon: PropTypes.node.isRequired,
  info: PropTypes.objectOf(PropTypes.any).isRequired
};

export default StatCard;
